import { render } from "./AdminInfoCard.vue?vue&type=template&id=fdf26452&scoped=true&ts=true"
import script from "./AdminInfoCard.vue?vue&type=script&lang=ts"
export * from "./AdminInfoCard.vue?vue&type=script&lang=ts"

import "./AdminInfoCard.vue?vue&type=style&index=0&id=fdf26452&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf26452"]])

export default __exports__